import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, auth } from "@/lib/api";
import { DISCLAIMER_FULL } from "@/lib/disclaimer";

export default function Disclaimer() {
  const navigate = useNavigate();
  const [a, setA] = useState(false);
  const [b, setB] = useState(false);
  const [loading, setLoading] = useState(false);

  const accept = async () => {
    if (!a || !b) return;
    setLoading(true);
    try {
      await api.post("/auth/ack-disclaimer", { disclaimer_read: a, licensed_professional: b });
      const u = auth.user();
      if (u) {
        u.disclaimer_acknowledged_at = new Date().toISOString();
        localStorage.setItem("medlogix_user", JSON.stringify(u));
      }
      toast.success("Disclaimer acknowledged and logged.");
      navigate(u?.baa_acknowledged ? "/dashboard" : "/baa");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save acknowledgment");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center p-6" data-testid="disclaimer-page">
      <div className="max-w-3xl w-full bg-white border border-brand rounded-2xl shadow-xl overflow-hidden">
        <div className="px-6 py-4 bg-amber-50 border-b border-amber-200 flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-700" />
          <div className="font-semibold text-amber-900 text-sm">Mandatory Clinical Decision Support Disclaimer</div>
        </div>
        <div className="px-6 py-5 max-h-[55vh] overflow-y-auto" data-testid="disclaimer-body">
          <pre className="whitespace-pre-wrap font-sans text-[13px] leading-relaxed text-brand-text">
            {DISCLAIMER_FULL}
          </pre>
        </div>
        <div className="px-6 py-4 border-t border-brand space-y-3">
          <label className="flex items-start gap-2.5 text-sm cursor-pointer">
            <input type="checkbox" checked={a} onChange={(e)=>setA(e.target.checked)}
              className="w-4 h-4 mt-0.5 accent-[#4A0E8F]" data-testid="disclaimer-check-1" />
            <span>I have read and understand the clinical decision support disclaimer.</span>
          </label>
          <label className="flex items-start gap-2.5 text-sm cursor-pointer">
            <input type="checkbox" checked={b} onChange={(e)=>setB(e.target.checked)}
              className="w-4 h-4 mt-0.5 accent-[#4A0E8F]" data-testid="disclaimer-check-2" />
            <span>I confirm I am a licensed healthcare professional and will not use platform outputs as a substitute for independent clinical judgment.</span>
          </label>
          <button onClick={accept} disabled={!a || !b || loading}
            className="w-full bg-brand-primary text-white py-2.5 rounded-md text-sm font-medium hover:bg-[#35096B] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            data-testid="disclaimer-accept">
            {loading ? "Logging acknowledgment…" : "I Acknowledge"}
          </button>
        </div>
      </div>
    </div>
  );
}
